module.exports = __webpack_public_path__ + "img/12.1f9ea80f.jpg";